import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import ChatbotVsAgenteDeIa from "@/pages/ChatbotVsAgenteDeIa";

export const Route = createFileRoute("/chatbot-vs-agente-de-ia")({
  head: () => buildHead({
    title: "Chatbot ou Agente de IA? Diferenças, custos e quando usar cada um",
    description: "Comparativo direto entre chatbot de fluxo e agente de IA generativa no WhatsApp e no Instagram: o que cada um resolve, limitações, custos e como usar os dois juntos.",
    path: "/chatbot-vs-agente-de-ia",
  }),
  component: ChatbotVsAgenteDeIa,
});
